import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const uploadResultXlsx = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UPLOAD_RESULT_EXCEL.METHOD](APIConfig.UPLOAD_RESULT_EXCEL.URL, payload,
        {'Content-Type': 'multipart/form-data'});
}

const getSessionDetails = (sessionID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SESSION_VIEW.METHOD](APIConfig.SESSION_VIEW.URL(sessionID), payload);
}

const generateResult = (sessionID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GENERATE_RESULT.METHOD](APIConfig.GENERATE_RESULT.URL(sessionID), payload);
}

const getGeneratedResultCount = (sessionID: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GENERATED_RESULT_COUNT.METHOD](APIConfig.GENERATED_RESULT_COUNT.URL(sessionID), payload);
}
const correctResult = (sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CORRECT_RESULT.METHOD](APIConfig.CORRECT_RESULT.URL(sampleId), payload);
}
const getResultLogs = (sampleId: any, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.RESULT_LOGS.METHOD](APIConfig.RESULT_LOGS.URL(sampleId), payload);
}

const getResultTestTemplate = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_RESULT_TEMPLATE.METHOD](APIConfig.TEST_RESULT_TEMPLATE.URL, payload);
}

const resultService = {
    uploadResultXlsx,
    getSessionDetails,
    generateResult,
    getGeneratedResultCount,
    correctResult,
    getResultLogs,
    getResultTestTemplate
}
export default resultService;
